<style src="./MobileControls.scss" lang="scss"></style>

<template lang="pug">
  .mobile-controls
    .mobile-controls__track(
      v-if='track'
    )
      Track(
        :track='track'
        :type='"small"'
      )
    .mobile-controls__actions
      .mobile-controls__group
        button.mobile-controls__button(
          @click='() => liked ? unlike(track.id) : like(track.id)'
          type='button'
        )
          .mobile-controls__icon.is-small
            Icon(
              :name='liked ? "heartFilled" : "heart"'
            )
          .mobile-controls__label {{ liked ? $l10n("REMOVE_FROM_FAVORITES") : $l10n("ADD_TO_FAVORITES") }}

        .mobile-controls__button.is-context-menu
          ContextMenu(
            :list='contextMenu'
            :title='$l10n("ADD_TO_PLAYLIST")'
            mode='addToPlaylist'
          )

      .mobile-controls__group
        button.mobile-controls__button(
          @click='toggleShuffle'
          type='button'
          :class='shuffle ? "is-enabled" : ""'
        )
          .mobile-controls__icon
            Icon(
              name="shuffle"
            )
          .mobile-controls__label {{ $l10n('SHUFFLE') }}
        button.mobile-controls__button(
          @click='toggleRepeat'
          type='button'
          :class='repeat != "none" ? "is-enabled" : ""'
        )
          .mobile-controls__icon
            Icon(
              :name='repeat === "track" ? "repeatOne" : "repeat"'
            )
          .mobile-controls__label {{ $l10n('REPEAT') }}

</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Track from "@/components/Track/Track";
import Icon from "@/components/Icon/Icon";
import ContextMenu from "@/components/ContextMenu/ContextMenu";
import Like from "@/components/Like/Like";

export default {
  name: "MobileControls",
  components: {
    Track,
    Icon,
    ContextMenu,
    Like
  },
  computed: {
    ...mapGetters({
      repeat: "player/repeat",
      shuffle: "player/shuffle",
      currentTrackId: "queue/currentTrackId",
      tracks: "tracks/tracks"
    }),
    contextMenu() {
      return this.$contextMenu.create({
        addToPlaylist: {
          single: true,
          tracks: [this.track.id]
        }
      });
    },
    track() {
      return this.tracks[this.currentTrackId];
    },
    liked() {
      try {
        return this.track.likes.liked;
      } catch (error) {
        return false;
      }
    }
  },
  methods: {
    ...mapActions({
      like: "tracks/like",
      unlike: "tracks/unlike"
    }),
    toggleShuffle() {
      this.$player.toggleShuffle();
    },
    toggleRepeat() {
      this.$player.toggleRepeat();
    },
    likeTrack() {
      this.like(this.track.id);
    },
    unlikeTrack() {
      this.unlike(this.track.id);
    }
  }
};
</script>
